import {
  Component,
  DestroyRef,
  ElementRef,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchMoleculeComponent } from 'src/app/components/input-switch-molecule/input-switch-molecule.component';
import { EditorModule } from 'primeng/editor';

import {
  FormFieldMoleculeComponent,
  LabelAtomComponent,
} from '@ls-commons/components';

import { HttpClient } from '@angular/common/http';
import { CheckboxModule } from 'primeng/checkbox';
import { ModalService } from '@ls-commons/utils/modals';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import jsPDF from 'jspdf';
import { format } from 'date-fns/format';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { NgIf } from '@angular/common';
// import {
//   symptomsValidator,
//   divingWithValidator,
//   divingTypeValidator,
// } from './checkboxes-required.validator';

@Component({
  selector: 'app-subworks-form',
  standalone: true,
  imports: [
    FormFieldMoleculeComponent,
    ButtonModule,
    SelectButtonModule,
    LabelAtomComponent,
    ReactiveFormsModule,
    SkeletonModule,
    CheckboxModule,
    InputSwitchMoleculeComponent,
    DropdownModule,
    EditorModule,
    CalendarModule,
    FieldsetModule,
    DividerModule,
    ToggleButtonModule,
    NgIf,
  ],
  templateUrl: './subworks-form.component.html',
  styleUrl: './subworks-form.component.scss',
})
export class SubworksFormComponent {
  subworksForm!: FormGroup;
  modalService = inject(ModalService);
  destroyRef = inject(DestroyRef);
  http = inject(HttpClient);
  // utilsService = inject(UtilsService);
  defaultDate = new Date();
  // price: number = 42.99;

  private _isLoading = signal<boolean>(true);
  public isLoading = computed(() => this._isLoading());

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    readonly fb: FormBuilder,
    private el: ElementRef
  ) {
    this.subworksForm = this.fb.group(
      {
        name: ['', Validators.required],
        nif: ['', Validators.required],
        nombre_director: ['', Validators.required],

        calle: ['', Validators.required],
        numero: ['', Validators.required],
        piso: ['', Validators.required],
        cp: ['', Validators.required],
        ciudad: ['', Validators.required],
        telefono: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]], //

        comun: [''],

        trabajos_offshore: [''],
        trabajos_petroleo: [''],

        explosivos: [''],

        registro_mantenimiento_equipos: [''],

        cobertura_maquinaria_sin_licencia: [''],

        embarcaciones: [''],

        sistemas_buceo: [''],
        producto_diferente_buceo: [''],

        acuerdos_no_reclamacion: [''],

        denegaciones_especiales: [''],

        firma: ['', Validators.required],
        fecha: [new Date(), Validators.required],
        cargo_empresa: ['', Validators.required],
        fecha_inicio_seguro: [new Date(), Validators.required],
      },
      {
        validators: [
          // symptomsValidator(),
          // divingWithValidator(),
          // divingTypeValidator(),
        ],
      }
    );
  }

  closeDialog() {
    this.ref.close(false);
  }

  sendForm() {
    // const form = this.subworksForm.getRawValue();
    // const observable$ =

    // this.subworksForm.controls['diving_with'].markAsTouched();
    this.subworksForm.markAllAsTouched();

    // console.log('subworksForm', this.subworksForm.controls);
    // console.log('form_values', form);

    if (this.subworksForm.valid) {
      const page = document.querySelector('.page') as HTMLElement;
      const subworksFormData = this.subworksForm.getRawValue();
      const { nif, fecha_inicio_seguro } = subworksFormData;

      const filename = `${nif} ${format(
        fecha_inicio_seguro || new Date(),
        'Y-m-d'
      )}.pdf`;
      const doc = new jsPDF();
      doc.setProperties({
        title: filename,
      });

      doc.html(page, {
        callback: doc => {
          // doc.save(filename);

          const pdfBlob = doc.output('blob');
          const reader = new FileReader();
          reader.readAsArrayBuffer(pdfBlob);
          reader.onloadend = () => {
            const pdfArrayBuffer = reader.result as ArrayBuffer;
            const url = `pdf/generate-prodiving-pdf?name=${nif}&accident_date=${fecha_inicio_seguro}`;
            this.http
              .post(url, pdfArrayBuffer, {
                responseType: 'text',
                headers: { 'Content-Type': 'application/pdf' },
              })
              .subscribe({
                next: () => {
                  this.modalService.showSuccessMessage(
                    `Su solicitud ha sido enviada correctamente.`
                  );

                  this.ref.close(true);
                },
                error: () => {
                  this.modalService.showErrorMessage(
                    `El proceso no se ha podido completar.`
                  );
                },
              });
          };
        },
        margin: 5,
        // x: 10,
        y: 5,
        width: 200,
        windowWidth: 900,
      });
    } else {
      this.modalService.showErrorMessage(
        `Es necesario rellenar todos los campos obligatorios`
      );
    }

    if (this.subworksForm.valid) {
      // Lógica para enviar el formulario
      console.log('Formulario enviado', this.subworksForm.value);
    } else {
      console.log('Formulario no válido');
    }
  }

  async subworksFormToPDF() {
    this.subworksForm.markAllAsTouched();

    // const order = this.orders.find(order => order.id == orderId);
    // await this.orderLineService
    //   .getElementsByOrderId(orderId)
    //   .subscribe(async (response: OrderLine[]) => {
    // generarMiPDF(order, response);

    // const ref = await this.dialogService.open(SubworksFormComponent, {
    //   dismissableMask: true,
    //   // closable: false,
    //   // closeOnEscape: false,
    //   header: 'Exportar a PDF',
    //   data: {
    //     // order,
    //     // orderLines: await response,
    //     autoExport: true,
    //   },
    //   width: '1000px',
    // });
    // });

    if (this.subworksForm.valid) {
      const page = document.querySelector('.page') as HTMLElement;
      const subworksFormData = this.subworksForm.getRawValue();
      const { name, accident_date } = subworksFormData;

      const filename = `${name} ${format(
        accident_date || new Date(),
        'Y-m-d'
      )}.pdf`;
      const doc = new jsPDF();
      doc.setProperties({
        title: filename,
      });

      doc.html(page, {
        callback: doc => {
          doc.save(filename);

          this.modalService.showSuccessMessage(
            `Formulario enviado correctamente`
          );

          // const pdfBlob = doc.output('blob');
          // const reader = new FileReader();
          // reader.readAsArrayBuffer(pdfBlob);
          // reader.onloadend = () => {
          //   const pdfArrayBuffer = reader.result as ArrayBuffer;
          //   const url = `pdf/generate-pdf?codigo=${codigo}&df_titular=${df_titular}`;
          //   this.http
          //     .post(url, pdfArrayBuffer, {
          //       responseType: 'text',
          //       headers: { 'Content-Type': 'application/pdf' },
          //     })
          //     .subscribe(
          //       response => {
          //         const pdfUrl = response;
          //         window.open(pdfUrl, '_blank');
          //         this.ref.close(true);
          //       },
          //       error => {
          //         console.error('Error generating PDF:', error);
          //       }
          //     );
          // };
        },
        margin: 5,
        // x: 10,
        y: 5,
        width: 200,
        windowWidth: 900,
      });
    } else {
      this.modalService.showErrorMessage(
        `Es necesario rellenar todos los campos obligatorios`
      );
    }
  }
}
